import script from "./kapan.vue?vue&type=script&setup=true&lang=js"
export * from "./kapan.vue?vue&type=script&setup=true&lang=js"

import "./kapan.vue?vue&type=style&index=0&id=4de9f695&scoped=true&lang=css"

import exportComponent from "/Users/hitenradadiya/Front/shiv_mfg_front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4de9f695"]])

export default __exports__